"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldReauthAdWordsForMultipleAccounts = exports.getUsersToAutomaticallyDeauth = exports.getLeadSyncingEntityToDelete = exports.getOpenLeadSyncingModal = exports.getInstallPixelModalOpen = void 0;

var _reselect = require("reselect");

var _once = _interopRequireDefault(require("hs-lodash/once"));

var _selectors = require("settings-ui-sdk/AdsAccounts/selectors");

var _constants = require("../constants.js");

var _selectors2 = require("settings-ui-sdk/Auth/selectors");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var getInteractions = function getInteractions(state) {
  return state.modules.marketing.ads.interactions;
};

var getInstallPixelModalOpen = (0, _reselect.createSelector)(getInteractions, function (interactions) {
  return interactions.get('installPixelModalOpen');
});
exports.getInstallPixelModalOpen = getInstallPixelModalOpen;
var getOpenLeadSyncingModal = (0, _reselect.createSelector)(getInteractions, function (interactions) {
  return interactions.get('openLeadSyncingModal');
});
exports.getOpenLeadSyncingModal = getOpenLeadSyncingModal;
var getLeadSyncingEntityToDelete = (0, _reselect.createSelector)(getInteractions, function (interactions) {
  return interactions.get('leadSyncingEntityToUnsubscribe');
});
exports.getLeadSyncingEntityToDelete = getLeadSyncingEntityToDelete;
var calculateDeauthOnce = (0, _once.default)(function (connectedUsers, adAccounts, hubSpotUserId) {
  return connectedUsers.filter(function (user) {
    return user.hubSpotUserId === hubSpotUserId;
  }).filter(function (user) {
    return !adAccounts.find(function (account) {
      return account.network === user.network && account.connectedUserId === user.userId;
    });
  }).toArray();
});
var getUsersToAutomaticallyDeauth = (0, _reselect.createSelector)(_selectors.getAdAccounts, _selectors.getConnectedUsers, _selectors2.getUserId, _selectors.getFetchAdAccountsRequestStatus, _selectors.getFetchConnectedUsersRequestStatus, _selectors.getDeleteAdAccountRequestStatus, _selectors.getDeleteUserAuthRequestStatus, function (adAccounts, connectedUsers, hubSpotUserId, connectedUsersRequestStatus, adAccountsRequestStatus, deleteAdAccountRequestStatus, deleteUserAuthRequestStatus) {
  // Make sure everything has fetched before we show the modal; additionally, deleting ad accounts
  // can result in interim spaces, and if the user has reached that point we will trust the backend
  // to clean up.
  if (connectedUsersRequestStatus !== _RequestStatusTypes.default.SUCCEEDED || adAccountsRequestStatus !== _RequestStatusTypes.default.SUCCEEDED || deleteAdAccountRequestStatus !== _RequestStatusTypes.default.UNINITIALIZED || deleteUserAuthRequestStatus !== _RequestStatusTypes.default.UNINITIALIZED) {
    return [];
  } // See if the currently logged in user has a user account connected without ad accounts


  return calculateDeauthOnce(connectedUsers, adAccounts, hubSpotUserId);
});
exports.getUsersToAutomaticallyDeauth = getUsersToAutomaticallyDeauth;
var shouldReauthAdWordsForMultipleAccounts = (0, _reselect.createSelector)(_selectors.getAdAccounts, function (adAccounts) {
  var connectedAdWordsAccount = adAccounts.find(function (account) {
    return account.network === _constants.Networks.ADWORDS;
  });
  return connectedAdWordsAccount && !connectedAdWordsAccount.connectedUserId;
});
exports.shouldReauthAdWordsForMultipleAccounts = shouldReauthAdWordsForMultipleAccounts;